import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface DiscardConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DiscardConfirmModal: React.FC<DiscardConfirmModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="discard-confirm-title"
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fadein"
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-xl p-6 w-[90vw] max-w-md animate-popin"
      >
        <h2 id="discard-confirm-title" className="text-lg font-bold text-gray-800 mb-2">
          再生成の確認
        </h2>
        <p className="text-sm text-gray-600 leading-relaxed mb-6">
          本当にいいですか？編集中の運指は破棄されます。
        </p>
        <div className="flex justify-end gap-2.5">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            いいえ
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg text-sm font-bold text-white bg-amber-600 hover:bg-amber-700 shadow-sm transition-colors"
          >
            はい、再生成する
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DiscardConfirmModal;
